export type Country = {
  countryId: number;
  countryName: string;
};
export type StateList = {
  stateID: number;
  countryID: number;
  stateName: string;
  stateCode: string;
};

export type CountryState = {
  data: Country[];
  loading: boolean;
  error: string | null;
};

export const initialState: CountryState = {
  data: [],
  loading: false,
  error: null,
};
export type CountryServiceOperators = {
  country: Country[];
  fetchAllCountry: () => void;
};
